import { useQuery } from '@hooks/reactQuery';

import { getFolderMoveDestinations } from '@api/portalFiles';

import { extractQueryParams } from '@utils/common';

import { IFolderMoveDestinations } from '@interfaces/portal/dto/foldersManagementDTO';

import { GET_PORTAL_FOLDERS_MOVE_DESTINATIONS } from '@constants/queryKeys';

interface IUseQueryPortalMilestoneReturned {
	isLoadingFoldersMoveDestinations: boolean;
	foldersMoveDestinations?: IFolderMoveDestinations;
}

export const useQueryFoldersMoveDestinations = (folderId?: string): IUseQueryPortalMilestoneReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IFolderMoveDestinations>({
			queryKey: [GET_PORTAL_FOLDERS_MOVE_DESTINATIONS, folderId],
			queryFn: extractQueryParams(getFolderMoveDestinations),
			enabled: [!!folderId],
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			refetchOnMount: true,
			staleTime: 0,
		},
	);

	return {
		isLoadingFoldersMoveDestinations: isInitialLoading,
		foldersMoveDestinations: data,
	};
};
